import { PersonModel } from '@/types';

export const person: PersonModel = {
  name: 'Wojciech',
  surname: 'Kozioł',
  position: 'Team Leader',
  linkedinLink: 'https://pl.linkedin.com/in/wojciech-koziol'
};
